import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.04853 0.337856C9.41423 0.585785 9.50971 1.08324 9.26178 1.44895L5.19413 7.44895C5.06129 7.64489 4.84849 7.77194 4.61298 7.79592C4.37747 7.81989 4.14343 7.73833 3.97383 7.57317L0.841479 4.52285C0.524942 4.2146 0.518222 3.70811 0.82647 3.39158C1.13472 3.07504 1.6412 3.06832 1.95774 3.37657L4.40578 5.7605L7.93744 0.551115C8.18536 0.185406 8.68282 0.089927 9.04853 0.337856Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "yandex-map-3-checkbox__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "yandex-map-3-checkbox",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["yandex-map-3-checkbox__control", { 'control--checked': _ctx.checked.value }])
    }, _hoisted_2, 2),
    (Boolean(_ctx.label))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ]))
}